import React from 'react';
import {Modal} from "@morningtrain/react-modals";
import Check from "../conditionals/Check";
import ForgotPasswordForm from "./ForgotPasswordForm";

export default class ForgotPasswordLink extends React.Component {

    openModal() {
        return this.modal.open()
    }

    renderModal() {
        return (
            <Modal ref={ref => this.modal = ref} label='Glemt Adgangskode'>
                <ForgotPasswordForm/>
            </Modal>
        );
    }

    render() {
        return (
            <Check negate={true}>
                <button onClick={this.openModal.bind(this)} type="button" className="forgot-password-link">Glemt adgangskode</button>
                {this.renderModal()}
            </Check>
        );
    }
}
